import React, { Component } from 'react'
import { Box/*, Text, TextInput, Select, Button, RadioButton*/ } from 'grommet';
import moment from "moment";
import { ERRORMESSAGE } from '../Constants.js';
import data from '../Data.json';
import "react-datepicker/dist/react-datepicker.css";
import { withRouter/*, Link*/ } from "react-router-dom";
import { DetailReportCtrl } from '../Controllers/Ebox/DetailReportCtrl';
import ReportStep1 from '../Components/ReportStep1';
import ReportStep2 from '../Components/ReportStep2';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
/*import { logout } from '../Utils/Utility';*/


class Report extends Component {
    constructor(props) {
        super(props)
        this.state = {
            startDate: '',
            endDate: '',
            startDateOut: '',
            endDateOut: '',
            numCarta: '',
            statusDisputa: '',
            valueDisputa: '',
            data: [],
            dataReport:[],
            step: 1,
            value: '',
            selected: '',
            selectedCode: '',
            status:'',
            msgNum: '',
            loading: false,
            showTimeoutModal: false,
            optionsReport: data.optionsReport,
            listaCodPv: this.props.listaCodPv

        }
        this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
        this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
        this.setNumeroCarta = this.setNumeroCarta.bind(this);
        this.setStatusDisputa = this.setStatusDisputa.bind(this);
        this.validNumber = this.validNumber.bind(this);
        this.detailReport = this.detailReport.bind(this);

    }



    validNumber(event) {
        var numCarta = this.state.numCarta;
        var number = /^\d+$/;

        if (event.target.id === 'numcarta') {
            if (numCarta !== '' && number.test(numCarta) === false) { // Validazione codice società
                this.setState({
                    msgNum: ERRORMESSAGE.msgnumber,
                    numCarta: ''
                })
            } else if (numCarta !== '' && number.test(numCarta) === true) {
                this.setState({
                    msgNum: ''
                })
            }
        }
    }

    setStatusDisputa(optionSelected) {
        let array = this.state.optionsReport;
        array.find(el => {
            if (el.label === optionSelected.value) {
                this.setState({
                    statusDisputa: el.label,
                    valueDisputa: el.value
                })
            }
            return null;
        })

    }

    setNumeroCarta(e) {
        this.setState({
            numCarta: e.target.value
        })

    }

    handleChangeStartDate(date) {
        var complDate = moment(date).format('DD/MM/YYYY');
        this.setState({
            startDate: date,
            startDateOut: complDate
        })

    }

    handleChangeEndDate(date) {
        var complDate = moment(date).format('DD/MM/YYYY')
        this.setState({
            endDate: date,
            endDateOut: complDate
        })
    }

    detailReport(e) {   
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        this.setState({
            loading: true
        }, () => {
            DetailReportCtrl(function (data, status) {
                //sessionStorage.setItem('riepilogo', JSON.stringify(data[0]))
                self.setState({
                    dataReport: data === undefined ? [] : data[0],
                    status: status,
                    loading: false
                });
                //self.props.nextStep();
            }, function (error) {
                self.setState({
                    status: error
                }, function () {
                    if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                        this.props.history.push({
                            pathname: '/ErrorPage',
                            state: this.state
                        })
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                    }
                })

            }, this.state, token, ids);
            this.nextStep();
        })
    }

    nextStep = () => {
        const { step } = this.state
        this.setState({
            step: step + 1
        })
    }
    prevStep = () => {
        const { step/*, gestPage*/ } = this.state
        this.setState({
            step: step - 1
        })
    }

    form(step) {
        const { codesoc, codepos, startDate, endDate, startDateOut, endDateOut, numCarta, statusDisputa, data, msgNum, optionsReport, valueDisputa, dataReport, listaCodPv, loading } = this.state;
        const values = { codesoc, codepos, startDate, endDate, startDateOut, endDateOut, numCarta, statusDisputa, data, msgNum, optionsReport, valueDisputa, dataReport, listaCodPv, loading };
        switch (step) {
            case 1:
                return <ReportStep1 values={values} nextStep={this.nextStep} setStatusDisputa={this.setStatusDisputa}
                    setNumeroCarta={this.setNumeroCarta} handleChangeStartDate={this.handleChangeStartDate}
                    handleChangeEndDate={this.handleChangeEndDate} validNumber={this.validNumber} detailReport={this.detailReport} />
            case 2:
                return <ReportStep2 values={values} prevStep={this.prevStep} printpage />
            default:
                return null;
        }
    }

    render() {
        const { step } = this.state;

        return (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box className='contentbox'>
                    <Box direction='row'>
                        {this.form(step)}
                    </Box>
                </Box>

            </Box>
        )
    }
}
export default Report = withRouter(Report)